export default {
  Turku: 'Turussa',
  Tohmajärvi: 'Tohmajärvellä',
  Ilomantsi: 'Ilomantsissa',
  Lieto: 'Liedossa',
  Muonio: 'Muoniossa',
  Kruunupyy: 'Kruunupyyssä',
  Kärsämäki: 'Kärsämäellä',
  Asikkala: 'Asikkalassa',
  Paikkakunta: 'Paikkakunnalla',
  Jyväskylä: 'Jyväskylässä',
  Hausjärvi: 'Hausjärvellä',
  Kangasala: 'Kangasalla',
  Loimaa: 'Loimaalla',
  Kankaanpää: 'Kankaanpäässä',
  Vårdö: 'Vårdössä',
  Veteli: 'Vetelissä',
  Tuusula: 'Tuusulassa',
  Rauma: 'Raumalla',
  Sipoo: 'Sipossa',
  Outokumpu: 'Outokummussa',
  Lapinlahti: 'Lapinlahdella',
  Viitasaari: 'Viitasaarella',
  Sauvo: 'Sauvossa',
  Kärkölä: 'Kärkölässä',
  Pyhäranta: 'Pyhärannassa',
  Sysmä: 'Sysmässä',
  Karvia: 'Karvialla',
  Ypäjä: 'Ypäjällä',
  Joroinen: 'Joroisilla',
  Föglö: 'Föglössä',
  Keitele: 'Kaustisella',
  Vehmaa: 'Vehmaalla',
  Lestijärvi: 'Lapinjärvellä',
  Mustasaari: 'Mustasaaressa',
  Raahe: 'Raahessa',
  Ikaalinen: 'Ikaalisissa',
  Eckerö: 'Eckerössä',
  Lappi: 'Lapissa',
  Lempäälä: 'Lempäälässä',
  Pomarkku: 'Pomarkussa',
  Hattula: 'Hattulassa',
  Iitti: 'Iitissä',
  Joensuu: 'Joensuussa',
  Oripää: 'Oripäässä',
  Siikajoki: 'Siikajoella',
  Keminmaa: 'Keminmaalla',
  Liperi: 'Liperissä',
  Puolanka: 'Puolangalla',
  Savukoski: 'Savukoskella',
  Simo: 'Simossa',
  Lumparland: 'Lumparlandissa',
  Vöyri: 'Vöyrillä',
  Salla: 'Sallassa',
  Kemiönsaari: 'Kemiönsaarella',
  Kivijärvi: 'Kivijärvellä',
  Lapinjärvi: 'Lapinjärvellä',
  Parikkala: 'Parikkalassa',
  'Koski Tl': 'Koskella',
  Ranua: 'Ranualla',
  Lumijoki: 'Lumijoella',
  Järvenpää: 'Järvenpäässä',
  Suomussalmi: 'Suomussalmella',
  Hammarland: 'Hammarlandissa',
  Mynämäki: 'Mynämäellä',
  Heinola: 'Heinolassa',
  Pyhäjärvi: 'Pyhäjärvellä',
  Pornainen: 'Pornaisissa',
  Maalahti: 'Maalahdella',
  Tervo: 'Tervossa',
  Rovaniemi: 'Rovaniemellä',
  Pihtipudas: 'Pihtiputaalla',
  Kuhmo: 'Kuhmossa',
  Petäjävesi: 'Petäjävedellä',
  Rautjärvi: 'Rautjärvellä',
  Kalajoki: 'Kalajoella',
  Humppila: 'Humppilassa',
  Imatra: 'Imatralla',
  Savitaipale: 'Savitaipaleella',
  Kumlinge: 'Kumlingessa',
  Lappeenranta: 'Lappeenrannassa',
  Vieremä: 'Vieremässä',
  Ruovesi: 'Ruovedellä',
  Kustavi: 'Kustavissa',
  Jämsä: 'Jämsässä',
  Korsnäs: 'Korsnäsissä',
  Pori: 'Porissa',
  Utajärvi: 'Utajärvellä',
  Janakkala: 'Janakkalassa',
  Halsua: 'Halsuassa',
  Brändö: 'Brändössä',
  Saarijärvi: 'Saarijärvellä',
  Kuusamo: 'Kuusamossa',
  Paimio: 'Paimiossa',
  Orivesi: 'Orivedellä',
  Miehikkälä: 'Miehikkälässä',
  Muhos: 'Muhoksella',
  Kuortane: 'Kuortaneella',
  Polvijärvi: 'Polvijärvellä',
  Enontekiö: 'Enontekiöllä',
  Puumala: 'Puumalassa',
  Siikainen: 'Siikaisissa',
  Tammela: 'Tammelassa',
  Kinnula: 'Kinnulassa',
  Sottunga: 'Sottungassa',
  Hankasalmi: 'Hankasalmella',
  Somero: 'Somerolla',
  Inari: 'Inarissa',
  Virrat: 'Virroilla',
  Ylitornio: 'Ylitorniossa',
  Ulvila: 'Ulvilassa',
  Merikarvia: 'Merikarvialla',
  Kiuruvesi: 'Kiuruvedellä',
  Kannus: 'Kannuksessa',
  Liminka: 'Limingassa',
  Uusikaupunki: 'Uudessakaupungissa',
  Punkalaidun: 'Punkalaitumella',
  Evijärvi: 'Evijärvellä',
  Virolahti: 'Virolahdella',
  Kaskinen: 'Kaskisissa',
  Juuka: 'Juukassa',
  Hyvinkää: 'Hyvinkäällä',
  Utsjoki: 'Utsjoella',
  Lemi: 'Lemissä',
  Kitee: 'Kiteellä',
  Vantaa: 'Vantaalla',
  Perho: 'Perhossa',
  Padasjoki: 'Padasjoella',
  Kauhajoki: 'Kauhajoella',
  Juupajoki: 'Juupajoella',
  Nummela: 'Nummelassa',
  Mikkeli: 'Mikkelissä',
  Salo: 'Salossa',
  Vaasa: 'Vaasassa',
  Aura: 'Aurassa',
  Rautalammi: 'Rautalammilla',
  Nokia: 'Nokialla',
  Mäntsälä: 'Mäntsälässä',
  Raisio: 'Raisiossa',
  Hartola: 'Hartolassa',
  Tornio: 'Torniossa',
  Nurmes: 'Nurmeksessa',
  Ii: 'Iissä',
  Pyhtää: 'Pyhtäällä',
  Hämeenlinna: 'Hämeenlinnassa',
  Pelkosenniemi: 'Pelkosenniemellä',
  Geta: 'Getassa',
  Haapavesi: 'Haapavedellä',
  Nakkila: 'Nakkilassa',
  Närpiö: 'Närpiössä',
  Heinävesi: 'Heinävedellä',
  'Mänttä-Vilppula': 'Mänttä-Vilppulassa',
  Haapajärvi: 'Haapajärvellä',
  Ähtäri: 'Ähtärissä',
  Hanko: 'Hangossa',
  Lappajärvi: 'Lappajärvellä',
  Kihniö: 'Kihniössä',
  Muurame: 'Muuramessa',
  Joutsa: 'Joutsassa',
  Myrskylä: 'Myrskylässä',
  Reisjärvi: 'Reisjärvellä',
  Kannonkoski: 'Kannonkoskella',
  Jämijärvi: 'Jämijärvellä',
  Kauhava: 'Kauhavalla',
  Juva: 'Juvalla',
  Kotka: 'Kotkassa',
  Merijärvi: 'Merijärvellä',
  Eura: 'Eurassa',
  Lemland: 'Lemlandissa',
  Naantali: 'Naantalissa',
  Jomala: 'Jomalassa',
  Kuopio: 'Kuopiossa',
  Hollola: 'Hollolassa',
  Kokemäki: 'Kokemäellä',
  Vaala: 'Vaalassa',
  Ylivieska: 'Ylivieskassa',
  Pedersöre: 'Pedersöressä',
  Karstula: 'Karstulassa',
  Kauniainen: 'Kauniaisissa',
  Riihimäki: 'Riihimäellä',
  Hämeenkyrö: 'Hämeenkyrössä',
  Leppävirta: 'Leppävirralla',
  Suonenjoki: 'Suonenjoella',
  Tuusniemi: 'Tuusniemellä',
  Luumäki: 'Luumäellä',
  Kouvola: 'Kouvolassa',
  Alavus: 'Alavudella',
  Kuhmoinen: 'Kuhmoisissa',
  Kolari: 'Kolarissa',
  Rääkkylä: 'Rääkkylässä',
  Laukaa: 'Laukaalla',
  Raasepori: 'Raaseporissa',
  Kittilä: 'Kittilässä',
  Kajaani: 'Kajaanissa',
  Harjavalta: 'Harjavalassa',
  Enonkoski: 'Enonkoskella',
  Pello: 'Pellossa',
  Kontiolahti: 'Kontiolahdella',
  Sievi: 'Sievissä',
  Lahti: 'Lahdessa',
  Pöytyä: 'Pöytyällä',
  Kurikka: 'Kurikassa',
  Kökar: 'Kökarilla',
  Taivalkoski: 'Taivalkoskella',
  Oulu: 'Oulussa',
  Porvoo: 'Porvoossa',
  Sonkajärvi: 'Sonkajärvellä',
  Kirkkonummi: 'Kirkkonummella',
  Äänekoski: 'Äänekoskella',
  Finström: 'Finströmissä',
  Maarianhamina: 'Maarianhaminassa',
  Hirvensalmi: 'Hirvensalmella',
  Urjala: 'Urjalassa',
  Uurainen: 'Uuraisissa',
  Keuruu: 'Keuruulla',
  Sastamala: 'Sastamalassa',
  Isojoki: 'Isojoella',
  Karkkila: 'Karkkilassa',
  Laitila: 'Laitilassa',
  Iisalmi: 'Iisalmessa',
  Toivakka: 'Toivakassa',
  ilmajoki: 'Ilmajoella',
  Forssa: 'Forssassa',
  Mäntyharju: 'Mäntyharjulla',
  Pyhäntä: 'Pyhännässä',
  Lieksa: 'Lieksassa',
  Savonlinna: 'Savonlinnassa',
  Pälkäne: 'Pälkäneellä',
  Rusko: 'Ruskossa',
  Pudasjärvi: 'Pudasjärvellä',
  Pieksämäki: 'Pieksämäellä',
  Pukkila: 'Pukkilassa',
  Teuva: 'Teuvassa',
  Tyrnävä: 'Tyrnävällä',
  Sund: 'Sundissa',
  Kaavi: 'Kaavissa',
  Nurmijärvi: 'Nurmijärvellä',
  Soini: 'Soinissa',
  Ylöjärvi: 'Ylöjärvellä',
  Vesilahti: 'Vesilahdella',
  Kaustinen: 'Kaustisissa',
  Parainen: 'Paraisissa',
  Vesanto: 'Vesannossa',
  Saltvik: 'Saltvikissä',
  Loppi: 'Lopella',
  Lapua: 'Lapualla',
  Pietarsaari: 'Pietarsaaressa',
  Espoo: 'Espoossa',
  Hyrynsalmi: 'Hyrynsalmella',
  Karijoki: 'Karijoella',
  Marttila: 'Marttilassa',
  Siuntio: 'Siuntiossa',
  Valtimo: 'Valtimossa',
  Kaarina: 'Kaarinassa',
  Siilinjärvi: 'Siilinjärvellä',
  Orimattila: 'Orimattilassa',
  Uusikaarlepyy: 'Uusikaarpelyyssä',
  Sulkava: 'Sulkavalla',
  Kerava: 'Keravalla',
  Masku: 'Maskussa',
  Rautavaara: 'Rautavaarassa',
  Akaa: 'Akaassa',
  Posio: 'Posiolla',
  Vimpeli: 'Vimpelissä',
  Taipalsaari: 'Taipalsaarella',
  Pertunmaa: 'Pertunmaalla',
  Oulainen: 'Oulaisissa',
  Taivassalo: 'Taivassalossa',
  Isokyrö: 'Isokyrössä',
  Toholammi: 'Toholammilla',
  Paltamo: 'Paltamossa',
  honkajoki: 'Honkajoella',
  Rantasalmi: 'Rantasalmella',
  Nivala: 'Nivalassa',
  Kyyjärvi: 'Kyyjärvellä',
  Laihia: 'Laihialla',
  Seinäjoki: 'Seinäjoella',
  Nousiainen: 'Nousiaisissa',
  Helsinki: 'Helsingissä',
  Multia: 'Multialla',
  Alajärvi: 'Alajärvellä',
  Loviisa: 'Lovisassa',
  Askola: 'Askolassa',
  Pirkkala: 'Pirkkalassa',
  Konnevesi: 'Konnevedellä',
  Vihti: 'Vihdissä',
  Kempele: 'Kempeleellä',
  Sodankylä: 'Sodankylässä',
  Ristijärvi: 'Ristijärvellä',
  Tampere: 'Tampereella',
  Luoto: 'Luodossa',
  Sotkamo: 'Sotkamossa',
  Kristiinankaupunki: 'Kristiinankaupungissa',
  Huittinen: 'Huittisissa',
  Parkano: 'Parkanossa',
  Valkeakoski: 'Valkeakoskella',
  Ruokolahti: 'Ruokolahdella',
  Luhanka: 'Luhangassa',
  Inkoo: 'Inkoossa',
  Hamina: 'Haminassa',
  Hailuoto: 'Hailuodossa',
  Kemi: 'Kemissä',
  Lohja: 'Lohjalla',
  Kangasniemi: 'Kangasniemessä',
  Kokkola: 'Kokkolassa',
  Eurajoki: 'Eurajoella',
  Varkaus: 'Varkaudessa',
  Säkylä: 'Säkylässä',
  Pyhäjoki: 'Pyhäjoella',
  Tervola: 'Tervolassa',
  Kemijärvi: 'Kemijärvellä',
  Alavieska: 'Alavieskassa',
  Siikalatva: 'Siikalatvassa',
  Pielavesi: 'Pielavedellä',
};
